import React from "react";
import {
  mfBasedOnObjective,
  growth,
  income,
  liquid,
  elss,
  capital,
  fixed
} from "../../../../data/mutualFundSeoPage";
import { textGenerator } from "./TextGenerator";

const BasedOnObjective = () => (
  <div>
    <h2>2. MUTUAL FUNDS BASED ON INVESTMENT OBJECTIVE</h2>
    {mfBasedOnObjective.map(text => {
      return textGenerator(text);
    })}
    {[growth, income, liquid, elss, capital, fixed].map(fund => {
      return (
        <>
          <h3>{fund.heading}</h3>
          {fund.content.map(text => {
            return textGenerator(text)
          })}
        </>
      );
    })}
  </div>
);

export default BasedOnObjective;
